import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTruck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10 22a1.92 1.92 0 0 0-.594-1.406A1.922 1.922 0 0 0 8 20a1.92 1.92 0 0 0-1.406.594A1.922 1.922 0 0 0 6 22c0 .542.198 1.01.594 1.406A1.92 1.92 0 0 0 8 24a1.92 1.92 0 0 0 1.406-.594A1.92 1.92 0 0 0 10 22zm-6-8h6v-4H7.531a.468.468 0 0 0-.343.14L4.14 13.188a.467.467 0 0 0-.141.344V14zm20 8a1.92 1.92 0 0 0-.594-1.406A1.922 1.922 0 0 0 22 20a1.92 1.92 0 0 0-1.406.594A1.922 1.922 0 0 0 20 22c0 .542.198 1.01.594 1.406A1.92 1.92 0 0 0 22 24a1.92 1.92 0 0 0 1.406-.594A1.92 1.92 0 0 0 24 22zm4-17v16c0 .156-.02.294-.063.414a.592.592 0 0 1-.21.29 5.102 5.102 0 0 1-.258.179c-.073.047-.196.078-.367.094-.172.015-.29.026-.352.03a4.733 4.733 0 0 1-.398 0L26 22a3.85 3.85 0 0 1-1.172 2.828A3.853 3.853 0 0 1 22 26a3.853 3.853 0 0 1-2.828-1.172A3.853 3.853 0 0 1 18 22h-6a3.85 3.85 0 0 1-1.172 2.828A3.854 3.854 0 0 1 8 26a3.854 3.854 0 0 1-2.828-1.172A3.854 3.854 0 0 1 4 22H3l-.352.008a4.734 4.734 0 0 1-.398 0l-.352-.031c-.171-.016-.294-.047-.367-.094a5.075 5.075 0 0 1-.258-.18.591.591 0 0 1-.21-.289A1.259 1.259 0 0 1 1 21c0-.27.099-.505.297-.703A.961.961 0 0 1 2 20v-5c0-.083-.003-.266-.008-.547s-.005-.479 0-.594c.005-.114.018-.294.04-.539.02-.245.054-.437.1-.578.048-.14.12-.3.22-.476.099-.178.216-.334.351-.47l3.094-3.093c.198-.198.46-.364.789-.5A2.41 2.41 0 0 1 7.5 8H10V5c0-.27.099-.505.297-.703A.961.961 0 0 1 11 4h16c.27 0 .505.099.703.297A.961.961 0 0 1 28 5z" />
  </svg>
);
export default SvgTruck;
